import { create } from "zustand";
import { type POAServiceProviderSource } from "@features/PowerOfAttorneyBillFormModal/types";

interface IProvider {
  /**
   * Combined id of serviceProviderId and companyCode
   */
  id: string;
  serviceProviderName: string;
  serviceProviderId?: number;
  companyCode?: string;
  selected: boolean;
  serviceProviderSource?: POAServiceProviderSource;
}

interface IPOAStore {
  providerList: Record<number, IProvider[]>;
  /**
   * Sets a list for selected provider
   */
  setProviderList: (
    jointBillServiceId: number,
    providerList: IProvider[],
  ) => void;
  setChecked: (
    jointBillServiceId: number,
    id: string,
    checked: boolean,
  ) => void;
  checkAll: (jointBillServiceId: number) => void;
  uncheckAll: (jointBillServiceId: number) => void;
  addProvider: (jointBillServiceId: number, provider: IProvider) => void;
  reset: () => void;
}

export const usePOAStore = create<IPOAStore>((set, get) => ({
  providerList: {},
  setProviderList: (jointBillServiceId, providerList) => {
    set(() => ({
      providerList: {
        ...get().providerList,
        [jointBillServiceId]: providerList,
      },
    }));
  },
  setChecked: (jointBillServiceId, id, checked) => {
    set((state) => ({
      providerList: {
        ...state.providerList,
        [jointBillServiceId]: state.providerList[jointBillServiceId]!.map(
          (provider) =>
            provider.id === id
              ? {
                  ...provider,
                  selected: checked,
                }
              : provider,
        ),
      },
    }));
  },
  checkAll: (jointBillServiceId) => {
    set((state) => ({
      providerList: {
        ...state.providerList,
        [jointBillServiceId]: state.providerList[jointBillServiceId]!.map(
          (provider) => ({
            ...provider,
            selected: true,
          }),
        ),
      },
    }));
  },
  uncheckAll: (jointBillServiceId) => {
    set((state) => ({
      providerList: {
        ...state.providerList,
        [jointBillServiceId]: state.providerList[jointBillServiceId]!.map(
          (provider) => ({
            ...provider,
            selected: false,
          }),
        ),
      },
    }));
  },
  addProvider: (jointBillServiceId, provider) => {
    set((state) => ({
      providerList: {
        ...state.providerList,
        [jointBillServiceId]: [
          provider,
          ...(state.providerList[jointBillServiceId] ?? []),
        ],
      },
    }));
  },
  reset: () => {
    set(() => ({
      providerList: {},
    }));
  },
}));
